// Hypothesis Playground — independent gate (pure logic). DEFAULT OFF.
// Lets the teaching layer (Failure Axis gallery) be reviewed/demoed without
// enabling the in-builder Hypothesis Engine. Mirrors validationPlaygroundFlag.

import { publicEnv } from './clientEnv';

export type HypothesisPlaygroundGate = { enabled: boolean; reason: string };

export const HYPOTHESIS_PLAYGROUND_OPTIN_KEY = 'hypothesis_playground_optin';
export const HYPOTHESIS_PLAYGROUND_KILL_KEY = 'hypothesis_playground_kill';

function ls(key: string): string | null {
  try { return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null; } catch { return null; }
}

export function hypothesisPlaygroundGate(): HypothesisPlaygroundGate {
  const on = (reason: string): HypothesisPlaygroundGate => ({ enabled: true, reason });
  const off = (reason: string): HypothesisPlaygroundGate => ({ enabled: false, reason });

  if (ls(HYPOTHESIS_PLAYGROUND_KILL_KEY) === '1') return off('local_kill');
  const e = (publicEnv('VITE_HYPOTHESIS_PLAYGROUND') ?? '').toLowerCase();
  if (e === 'on') return on('env_on');
  if (e === 'off') return off('disabled_globally');
  if (ls(HYPOTHESIS_PLAYGROUND_OPTIN_KEY) === '1') return on('local_optin');
  return off('default_off');
}
